// Reports.tsx
import React from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
// import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Box } from "@mui/material";
import {
  FinanceData,
  //  Expense, ExtraIncome,
  FinanceDataValues,
} from "../types";

// Register ChartJS components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface ReportsProps {
  financeData: FinanceData;
  updateFinancialData?: (item: string, value: FinanceDataValues) => void;
  pdfAreaId?: string;
}

const TotalsCards: React.FC<ReportsProps> = ({
  financeData,
  updateFinancialData,
  pdfAreaId,
}) => {
  // Calculate summary stats
  const totalExpenses = financeData.expenses.reduce(
    (sum, exp) => sum + exp.amount,
    0
  );
  const totalExtraIncome = financeData.extraIncome.reduce(
    (sum, inc) => sum + inc.amount,
    0
  );
  const netSavings =
    Number(financeData.expectedIncome) +
    Number(totalExtraIncome) -
    Number(totalExpenses);

  // Prepare chart data
  // const chartData = {
  //   labels: ['Expected Income', 'Extra Income', 'Expenses', 'Expected Savings'],
  //   datasets: [
  //     {
  //       label: 'Amount ($)',
  //       data: [
  //         financeData.expectedIncome,
  //         totalExtraIncome,
  //         totalExpenses,
  //         financeData.expectedSavings,
  //       ],
  //       backgroundColor: ['#4CAF50', '#2196F3', '#F44336', '#FF9800'],
  //     },
  //   ],
  // };

  // const chartOptions = {
  //   responsive: true,
  //   plugins: { legend: { position: 'top' as const } },
  // };

  // Updated PDF Export function using html2canvas
  const exportToPDF = async () => {
    try {
      const element = document.getElementById(`${pdfAreaId ?? ""}`);
      if (!element) {
        throw new Error("PDF section element not found");
      }

      // Capture the element as canvas
      const canvas = await html2canvas(element, {
        scale: 2, // Higher scale for better quality
        useCORS: true, // For external images if any
        windowWidth: document.body.scrollWidth, // Ensure full width capture
        windowHeight: document.body.scrollHeight, // Ensure full height capture
        scrollX: 0,
        scrollY: 0,
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: "a4",
      });

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgProps = pdf.getImageProperties(imgData);
      const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;

      // Handle multi-page PDF if content is taller than one page
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight);
      heightLeft -= pdfHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight);
        heightLeft -= pdfHeight;
      }

      pdf.save(`${financeData.title}_report.pdf`);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  return (
    <div style={{ padding: "20px", maxWidth: "1200px", margin: "0 auto" }}>
      {/* Summary Stats */}
      <Box
        sx={{
          display: {sm:"grid",xs:'flex'},
          flexDirection:'column',
          gridTemplateColumns:{lg:'repeat(4, 1fr)',md:'repeat(2, 1fr)',xs:'repeat(1, 1fr)'},
          // flexDirection:{xs:'column',sm:'row'},
          gap:2,
          flexWrap:'wrap',
          margin: "20px 0",
        }}
      >
        <Box
          sx={{
            textAlign: "center",
            padding: "10px",
            background: "#f0f0f0",
            borderRadius: "8px",
   
          }}
        >
          <h3>Expected Income</h3>
          <p style={{ color: "#4CAF50" }}>${financeData.expectedIncome}</p>
        </Box>
        <Box
          sx={{
            textAlign: "center",
            padding: "10px",
            background: "#f0f0f0",
            borderRadius: "8px",
      
          }}
        >
          <h3>Extra Income</h3>
          <p style={{ color: "#2196F3" }}>${totalExtraIncome}</p>
        </Box>
        <Box
          sx={{
            textAlign: "center",
            padding: "10px",
            background: "#f0f0f0",
            borderRadius: "8px",
      
          }}
        >
          <h3>Expenses</h3>
          <p style={{ color: "#F44336" }}>${totalExpenses}</p>
        </Box>
        <Box
          sx={{
            textAlign: "center",
            padding: "10px",
            background: "#f0f0f0",
            borderRadius: "8px",
     
          }}
        >
          <h3>Net Savings</h3>
          <p style={{ color: netSavings >= 0 ? "#4CAF50" : "#F44336" }}>
            ${netSavings}
          </p>
        </Box>
      </Box>

      {/* Notes */}
      <h2>Notes</h2>
      {updateFinancialData ? (
        <textarea
          style={{resize:'none',width:'100%',height:'80px'}}
          value={financeData.notes}
          onChange={(e) => {
            if (e?.target?.value) {
              updateFinancialData("notes", e.target.value);
            }
          }}
        />
      ) : (
        <>{financeData.notes}</>
      )}
      {/* Export Button */}
      {pdfAreaId && (
        <button
          onClick={exportToPDF}
          style={{
            display: "block",
            margin: "20px auto",
            padding: "10px 20px",
            background: "#007BFF",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Generate Image PDF
        </button>
      )}
    </div>
  );
};

export default TotalsCards;
